import {Component} from '@angular/core';
import {isWebView, LocalizationService, RouterService, TypedForm} from '@npck/libs/commons';
import {AuthHolderService} from '../../domain/auth-holder.service';
import {DOCUMENT_TYPE} from '../../domain/query-param.keys';
import {Path} from '../../path';
import {DocumentType} from '../document/document.component';

@Component({
    templateUrl: 'iin.component.html',
    styleUrls: ['iin.component.scss'],
    standalone: false
})
export class IinComponent {
    iin: string;
    form: TypedForm<IinForm>;

    agreementsPaths: string[] = [Path.IIN, Path.BIN];
    Path = Path;
    userAgreementUrl: string;
    privacyPolicyUrl: string;
    documentsTarget: string;
    agreementsRequired: boolean;
    agreementsChecked = false;

    constructor(
        public routerService: RouterService,
        public oauthHolderService: AuthHolderService,
        private localizationService: LocalizationService,
    ) {
        this.iin = oauthHolderService.authSessionData.iin;
        this.agreementsRequired = this.agreementsPaths.includes(routerService.getCurrentUrl().slice(1));
        this.setDocumentUrls();
        this.localizationService.language$.subscribe(() => this.setDocumentUrls());
    }

    submit(): void {
        this.gotoLiveness();
    }

    private setDocumentUrls(): void {
        if (isWebView()) {
            this.userAgreementUrl = `${Path.DOCUMENT}?${DOCUMENT_TYPE}=${DocumentType.USER_AGREEMENT}`;
            this.privacyPolicyUrl = `${Path.DOCUMENT}?${DOCUMENT_TYPE}=${DocumentType.PRIVACY_POLICY}`;
            this.documentsTarget = '_self';
        } else {
            const locale = this.localizationService.currentLanguage.locale;
            this.userAgreementUrl = `/assets/documents/user-agreement-${locale}.pdf`;
            this.privacyPolicyUrl = `/assets/documents/privacy-policy-${locale}.pdf`;
            this.documentsTarget = '_blank';
        }
    }

    private gotoLiveness(): void {
        this.routerService.navigate(Path.LIVENESS);
    }
}

interface IinForm {
    iin: string;
}
